import { apiClient } from '../../../../helpers/api_helper';

export const getAllStoreData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/Store/GetAllStoreList`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getAllStoreForSelect = async () => {
    try {
        const response = await apiClient.get(`/api/v1/Store/GetStoresSelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};


export const getStoreTypeForSelect = async () => {
    try {
        const response = await apiClient.get(`/api/v1/Store/GetStoreTypeSelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getStoreById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/store/GetStoreDetailsById?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};
